export default __webpack_public_path__ + "static/media/circle.04a5d147.svg";